'use client';

import type { PropsWithChildren } from 'react';
import {
  ClientNameContextProvider,
  type ClientNames,
} from '@frameio/shared/contexts/ClientNameContext';
import { useUxpHostInfoContext } from '../contexts/UxpHostInfoContext';

export function HostNameProvider({ children }: PropsWithChildren) {
  const { name } = useUxpHostInfoContext();

  return (
    <ClientNameContextProvider name={(name || 'unknown') as ClientNames}>
      {children}
    </ClientNameContextProvider>
  );
}
